import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthStore } from '../../store/auth.store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
export default function ProtectedRoute() {
    const { isAuthenticated, hasRehydrated, isLoading, checkAuth, token } = useAuthStore();
    const location = useLocation();
    // Check auth on mount (but only after rehydration)
    useEffect(() => {
        if (hasRehydrated) {
            checkAuth();
        }
    }, [hasRehydrated, checkAuth]);
    // Wait for rehydration to complete before making any decisions
    if (!hasRehydrated) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg", children: _jsxs("div", { className: "flex flex-col items-center gap-4", children: [_jsx(Loader2, { className: "h-12 w-12 animate-spin text-purple-500" }), _jsx("p", { className: "text-sm text-light-text-muted dark:text-dark-text-muted", children: "Loading..." })] }) }));
    }
    // If loading auth check, show loading
    if (isLoading) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg", children: _jsxs("div", { className: "flex flex-col items-center gap-4", children: [_jsx(Loader2, { className: "h-12 w-12 animate-spin text-purple-500" }), _jsx("p", { className: "text-sm text-light-text-muted dark:text-dark-text-muted", children: "Verifying session..." })] }) }));
    }
    // After checkAuth resolves — if still not authenticated, redirect
    if (!isAuthenticated && !token) {
        return _jsx(Navigate, { to: `/login?redirect=${encodeURIComponent(location.pathname + location.search)}`, replace: true });
    }
    // Fallback: if we have a token but isAuthenticated somehow false, trust the token
    if (!isAuthenticated && token) {
        return _jsx(Outlet, {});
    }
    return _jsx(Outlet, {});
}
